import { useEffect, useState } from "react";

import {
  ResearchApiPost,
  fetchResearchPosts,
} from "../services/researchService";

export const useResearchPosts = (page: number, pageSize: number) => {
  const [posts, setPosts] = useState<ResearchApiPost[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadPosts = async () => {
      setLoading(true);
      try {
        const { posts: data, totalCount: count } = await fetchResearchPosts({
          page,
          pageSize,
        });
        if (isMounted) {
          setPosts(data);
          setTotalCount(count);
        }
      } catch (error) {
        console.error("Failed to load research posts", error);
        if (isMounted) {
          setPosts([]);
          setTotalCount(0);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPosts();

    return () => {
      isMounted = false;
    };
  }, [page, pageSize]);

  return { posts, totalCount, loading };
};
